// extracted by mini-css-extract-plugin
export default {"statisticsCard":"CardStatistics_statisticsCard__JSORP","description":"CardStatistics_description__59FIV"};